import { supabase } from '../config/supabaseConfig.ts';

export const planService = {
  getAll: async (onlyActive = false) => {
    let q = supabase.from('plans').select('*').order('name');
    if (onlyActive) q = q.eq('is_active', true);
    const { data, error } = await q;
    if (error) throw error;
    return data || [];
  },

  // Devuelve { [plan_id]: count } con número de usuarios por plan
  getUserCounts: async () => {
    const { data, error } = await supabase
      .from('user_settings')
      .select('plan_id');
    if (error) throw error;
    const counts = {};
    (data || []).forEach(s => {
      if (s.plan_id) counts[s.plan_id] = (counts[s.plan_id] || 0) + 1;
    });
    return counts;
  },

  create: async ({ name, text_limit_weekly, voice_limit_weekly }) => {
    const { data, error } = await supabase
      .from('plans')
      .insert({ name, text_limit_weekly, voice_limit_weekly, is_active: true })
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  update: async (id, updates) => {
    const { data, error } = await supabase
      .from('plans')
      .update(updates)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  deactivate: async (id) => {
    const { error } = await supabase
      .from('plans')
      .update({ is_active: false })
      .eq('id', id);
    if (error) throw error;
  },
};
